module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album_large_en-6bd2f073dc47c3705a22bc211a960b06.png";